import type { UrlService } from './url';

/**
 * Adds filters params to the URL.
 */
export function SetURLParams(this: UrlService): void {
  // Ensure the initial URL params have been read and applied to the filtering service before we attempt to set any URL params.
  if (!this.initialParamsRead()) {
    return;
  }

  if (!this.filteringService.hasFilters() && JSON.stringify(this.params()) === '{}') {
    //create default filter for params comparisson so that if there are no filters active and no params to set we don't unnecessarily update the URL and cause a re-render
    return;
  }

  const _params = {};

  for (const [_key, _value] of Object.entries(this.params())) {
    switch (_key) {
      case 'geoWithin':
      case 'ids':
        // Removes these keys from the URL since they are essentially silent filters (not visible to the user).
        continue;
      case 'pending':
        if (_value === true) {
          Object.assign(_params, { [_key]: _value });
        }
        continue;
      case 'pool':
        if (_value === true) {
          Object.assign(_params, { pool: _value });
        }
        continue;
      case 'onlyOpenHouses':
        if (_value === true) {
          Object.assign(_params, { openHomes: _value });
        }
        continue;
      case 'garage-predefined':
        if (_value) {
          Object.assign(_params, { garages: _value });
        }
        continue;
      case 'unit':
        if (_value) {
          Object.assign(_params, { unit: [_value] });
        }
        continue;
      case 'models':
        if (_value) {
          Object.assign(_params, { models: _value });
        }
        continue;
      case 'search':
        if (_value) {
          Object.assign(_params, { search: _value });
        }
        continue;
      default:
        break;
    }

    if (_value !== undefined && !['community', 'limit'].includes(_key)) {
      if (_key === 'sort' && _value === 'openTodayStart:asc,openTomorrowStart:asc,date:desc') {
        continue;
      }
      if (_key === 'saleTypes' && _value === 'new,preowned') {
        continue;
      }

      Object.assign(_params, { [_key]: _value });
    }
  }

  if (this.activatedRoute.snapshot.queryParams.noAuth) {
    Object.assign(_params, { noAuth: true });
  }

  if (!this.initialParamsPopulated) {
    // The initial URL params are being set so there is no need to update the URL or notify the parent window.
    this.initialParamsPopulated = true;

    return;
  }

  this.urlParams.set(
    new URLSearchParams(_params).toString().replaceAll('%2C', ',').replaceAll('+', '%20'),
  );
}
